export const getPartners = (state: { partners: any; }) => {
    return state.partners;
};

export const getPartner = (state: { partner: any; }) => {
    return state.partner;
};
